/**
 * The build-time landing page (`scripts/prerender-landing.mjs`) and the app's own render of it.
 *
 * On `/`, for a visitor with no stored session, the inline script in `index.html` paints the
 * prerendered page into `#landing-prerender` and hides `#root` while the app loads. When the app has
 * rendered what belongs on `/`, it calls this, in a layout effect, so the swap happens inside one
 * frame: the prerendered copy leaves, `#root` shows, and the reader keeps their scroll position.
 *
 * Callers: `LandingPage` (the app's landing is ready) and `LandingOrDashboard` (a signed-in visitor
 * is being sent to the dashboard after all). Safe to call any number of times, on any route.
 */
export function releasePrerender() {
  const root = document.getElementById('root')
  const shell = document.getElementById('landing-prerender')
  if (root) root.hidden = false
  if (!shell) return
  const from = shell.querySelector<HTMLElement>('[data-landing-scroller]')
  const to = root?.querySelector<HTMLElement>('[data-landing-scroller]')
  if (from && to) to.scrollTop = from.scrollTop
  shell.remove()
}
